import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const Copy: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M13.3346 0.833374H3.33464C2.41797 0.833374 1.66797 1.58337 1.66797 2.50004V14.1667H3.33464V2.50004H13.3346V0.833374ZM12.5013 4.16671L17.5013 9.16671V17.5C17.5013 18.4167 16.7513 19.1667 15.8346 19.1667H6.65964C5.74297 19.1667 5.0013 18.4167 5.0013 17.5L5.00964 5.83337C5.00964 4.91671 5.7513 4.16671 6.66797 4.16671H12.5013ZM11.668 10H16.2513L11.668 5.41671V10Z" />
  </SvgIcon>
);
